import { render, staticRenderFns } from "./overlay.generic.vue?vue&type=template&id=534cd7a2&"
import script from "./overlay.generic.vue?vue&type=script&lang=js&"
export * from "./overlay.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports